import React from 'react'
import TabbedList from './DashboardTabbedList'

const DashboardList = props => (
  <TabbedList {...props} />
)

export default DashboardList
